import {TeTemplateService} from "./service/api/te-template.service";
import {TeArtefactService} from "./service/api/te-artefact.service";
import {TeArtefactVariableService} from "./service/api/te-artefact-variable.service";
import {TeTemplateVariableService} from "./service/api/te-template-variable.service";
import {TeTemplateBlueprintService} from "./service/api/te-template-blueprint.service";
import {TeTemplateBlueprintArtefactService} from "./service/api/te-template-blueprint-artefact.service";
import {TeTemplateBlueprintVariableService} from "./service/api/te-template-blueprint-variable.service";
import {
    TeTemplateBlueprintArtefactVariableLinkService
} from "./service/api/te-template-blueprint-artefact-variable-link.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {TeTemplateObjectComponent} from "./component/protected-components/te-template/te-template-object.component";
import {TeArtefactObjectComponent} from "./component/protected-components/te-artefact/te-artefact-object.component";
import {TeBlueprintObjectComponent} from "./component/protected-components/te-blueprint/te-blueprint-object.component";

export const TE_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['te.TeTemplate', {route: 'te/config', service: TeTemplateService, objectComponent: [{component: TeTemplateObjectComponent}]}],
            ['te.TeSystemVariablePredefined', {route: '/te/teSystemVariablePredefineds'}],

            ['te.TeTemplateGroup', {route: '/te/teTemplateGroups'}],
            ['te.TeTemplateArtefact', {route: '/te/teTemplateArtefacts'}],
            ['te.TeArtefact', {route: 'te/config', service: TeArtefactService, objectComponent: [{component: TeArtefactObjectComponent}]}],
            ['te.TeArtefactGroup', {route: '/te/teArtefactGroups'}],
            ['te.TeArtefactVariable', {route: 'te/config', service: TeArtefactVariableService}],
            ['te.TeTemplateVariable', {route: 'te/config', service: TeTemplateVariableService}],
            ['te.TeTemplateArtefactVariableLink', {route: '/te/teTemplateArtefactVariableLinks'}],
            ['te.TeTestCase', {route: '/te/teTestCases'}],
            ['te.TeTestCaseVariable', {route: '/te/teTestCaseVariables'}],
            ['te.TeTemplateTestCase', {route: '/te/teTemplateTestCases'}],
            ['te.TeArtefactTestCase', {route: '/te/teArtefactTestCases'}],

            ['te.TeTemplateBlueprint', {route: 'te/config', service: TeTemplateBlueprintService, objectComponent: [{component: TeBlueprintObjectComponent}]}],
            ['te.TeTemplateBlueprintArtefact', {route: 'te/config', service: TeTemplateBlueprintArtefactService}],
            ['te.TeTemplateBlueprintVariable', {route: 'te/config', service: TeTemplateBlueprintVariableService}],
            ['te.TeTemplateBlueprintArtefactVariableLink', {route: 'te/config', service: TeTemplateBlueprintArtefactVariableLinkService}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
